module.exports = __webpack_public_path__ + "static/media/banner_s_03.7affd7a0.jpg";